import React, { useState } from "react"
import { Link } from "react-router-dom"
import classNames from "classnames"
import { useHistory } from "react-router-dom"

import styles from "./CompanyOpportunities.module.scss"
import CompanyInfoItem from "../CompanyInfoItem/CompanyInfoItem"
import OpportunityCard from "../cards/OpportunityCard"
import CompanyAddonTypePopup from "../CompanyAddonTypePopup"
import { opportunitiesTypeCards } from "../Opportunity/heplers"
import { DEFAULT_PROFILE_IMAGE as avatar } from "../../helpers/profileImage"

const CompanyOpportunities = ({ data, width, anotherUser, uuid }) => {
  const [visiblePopup, setVisiblePopup] = useState(false)
  const history = useHistory()

  const handleClick = (e, opportunitie) => {
    if (e.target.dataset.type !== "button") {
      history.push(`/opportunity?id=${opportunitie["uuid"]}`)
    }
  }

  const tooltipText = data?.departments?.length
    ? null
    : "Please add at least one department before adding an opportunity."

  // Only use opportunities array - backend already filters out private ones
  // Double-check to ensure no private opportunities slip through
  const publicOpportunities = (data?.opportunities || []).filter((opp) => opp.is_private !== true)
  const placeholder =
    anotherUser && publicOpportunities.length === 0
      ? "No opportunity yet"
      : publicOpportunities.length > 0
      ? null
      : "You didn't add any opportunities yet"

  const addButtonDisabledStatus = !data?.departments?.length

  return (
    <CompanyInfoItem
      tooltipText={tooltipText}
      headTitle={
        anotherUser ? "Company/Organization Opportunities" : "My Opportunities"
      }
      disabled={addButtonDisabledStatus}
      headBtnText={width < 451 ? "Add" : "Add Opportunity"}
      bodyPlaceholderText={placeholder}
      handleButtonClick={() => {
        setVisiblePopup(true)
      }}
      width={width}
      anotherUser={anotherUser}
    >
      <div className={styles.oppotunitiesWrapper}>
        {visiblePopup && (
          <CompanyAddonTypePopup
            width={953}
            closeAction={setVisiblePopup}
            title="Add Opportunity"
            handleNextClick={(a) =>
              history.push(`/opportunity-edit?variant=${a.type}`)
            }
            data={opportunitiesTypeCards}
          />
        )}
        {publicOpportunities.length > 0 && (
          <>
            <div className={styles.cardsWrapper}>
              {publicOpportunities.map((opportunitie) => (
                  <OpportunityCard
                    key={opportunitie["created_at"]}
                    uuid={opportunitie.uuid}
                    type={opportunitie["opportunity_type"]}
                    avatar={data.photo || avatar}
                    description={opportunitie["description"]}
                    location={{
                      city: opportunitie["location"],
                      head: data.name,
                    }}
                    caption={opportunitie["name"]}
                    timestamp={new Date(opportunitie["created_at"])}
                    onClick={(e) => handleClick(e, opportunitie)}
                    isFavorite={opportunitie["favorite"]}
                    isPrivate={false}
                  />
                ))}
            </div>

            {publicOpportunities.length >= 2 && (
              <div className={styles.showMoreBtn}>
                <Link
                  to={`/opportunities/${uuid}`}
                  className={classNames("goldLink")}
                >
                  <p>Show all opportunities</p>
                </Link>
              </div>
            )}
          </>
        )}
      </div>
    </CompanyInfoItem>
  )
}

export default CompanyOpportunities
